/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ lineNumber: NonNullable<unknown> }} Network_Lines_LabelInputs */

const fr_network_lines_label = /** @type {(inputs: Network_Lines_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ligne ${i?.lineNumber}`)
};

const en_network_lines_label = /** @type {(inputs: Network_Lines_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Line ${i?.lineNumber}`)
};

/**
* | output |
* | --- |
* | "Line {lineNumber}" |
*
* @param {Network_Lines_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_lines_label = /** @type {((inputs: Network_Lines_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Lines_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_network_lines_label(inputs)
	return en_network_lines_label(inputs)
});